import React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'

import cx from '../utils/cx'

const headingClasses =
  'text-gray-600 font-primary font-bold text-center uppercase'

export function LandingTitle({ className = '', ...props }) {
  return (
    <h2
      className={cx(
        'text-2xl tracking-tight md:text-3xl',
        headingClasses,
        className
      )}
      {...props}
    />
  )
}

export function LandingSubtitle({ className = '', ...props }) {
  return (
    <h3
      className={cx(
        'mt-2 text-center font-secondary text-xl font-light md:text-2xl',
        className
      )}
      {...props}
    />
  )
}

export function ProjectTitle({ title }) {
  return (
    <h1 className="mt-2 max-w-xl font-primary text-2xl font-light leading-8 tracking-tight sm:mt-3 sm:text-4xl">
      {title}
    </h1>
  )
}

export function EnglishOnly() {
  const { t } = useTranslation()
  const { language } = useI18next()

  if (language !== 'en') {
    return <div>{t('shared.englishOnly')}</div>
  }
}
